/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaToggle/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaToggle({
  children,
  viewPath = "/DesignSystem/TysiaToggle",
  marginTop = 16,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  width,
  justifyContent = "center",
  onClick,
  disabled,
  onMouseEnter,
  onMouseLeave,
  selected,
  hovered,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  return (<React.Fragment
>
<button
  data-testid="TysiaToggle.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={disabled}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--mt-1-Nlql5': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-2-Nlql5': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-3-Nlql5': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Nlql5': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--w-5-Nlql5': typeof width === 'number' ? `${width}px` : width,'--jc-6-Nlql5': justifyContent,'--c-7-Nlql5': disabled ? "normal" : "pointer",'--o-8-Nlql5': disabled ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 selected={selected}
 hovered={hovered}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}